export const NOT_CLOSED_STATUSES = ['open', 're-opened'];

export const buildVulnsCountParams = ({ confirmed = false, notClosed = false } = {}) => {
  const parts = [];
  if (confirmed) parts.push('confirmed=true');
  if (notClosed) {
    NOT_CLOSED_STATUSES.forEach((status) => parts.push(`status=${encodeURIComponent(status)}`));
  }
  return parts.length ? `&${parts.join('&')}` : '';
};
